// 1.

// import React, { useState, useEffect, useRef } from "react";
// import { TbRefresh } from "react-icons/tb";
// import axios from "axios";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { Line } from "react-chartjs-2";
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend,
// } from "chart.js";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// export function getDateTimeForDashboardTab1(date = new Date()) {
//     const formattedCurrentDate = date.toISOString().split("T")[0];
//     const oneWeekAgo = new Date(date);
//     oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
//     const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];
//     return {
//         Today: formattedCurrentDate,
//         LastWeek: formattedOneWeekAgo,
//     };
// }

// function AnalyticsTab1() {
//   const chartRef = useRef();
//   const [users, setUsers] = useState([]);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [inverters, setInverters] = useState([]);
//   const [compareInverters, setCompareInverters] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
//   const [metric, setMetric] = useState("ENG");
//   const [loading, setLoading] = useState(false);

//   // ✅ Credentials
//   const credentials = {
//     USER_ID: localStorage.getItem("LOGIN_ID"),
//     Password: localStorage.getItem("PASSWORD"),
//     SS_KEY: localStorage.getItem("SS_KEY"),
//   };

//   // ✅ Fetch Users on Mount
//   useEffect(() => {
//     axios
//       .get(`${BaseUrl}CMN_07_Super/GET_USER_LIST`, { params: credentials })
//       .then((res) => setUsers(res.data.data || []))
//       .catch((err) => console.error("User API Error:", err));
//   }, []);

//   // ✅ Fetch Inverters for Selected User
//   const fetchInverters = async (user) => {
//     try {
//       const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//         params: {
//           LOGIN_ID: user.ID,
//           LOC_CODE: user.loc_code,
//           PASS_KEY: user.password,
//           WEB_KEY: "WEBXYZ321",
//           TYP: "I",
//         },
//       });
//       setInverters(res.data.FEED || []);
//     //   setCompareInverters([]);
//       setChartData(null);
//     } catch (err) {
//       console.error("Inverter API Error:", err);
//     }
//   };

//   const handleUserSelect = (user) => {
//     setSelectedUser(user);
//     fetchInverters(user);
//   };



//   const toggleCompareInverter = (inv) => {
//     setCompareInverters((prev) =>
//       prev.some((c) => c.feeder_id === inv.feeder_id)
//         ? prev.filter((c) => c.feeder_id !== inv.feeder_id)
//         : [...prev, { ...inv, user_name: selectedUser.user_name }]
//     );
//   };


//   // ✅ Fetch Performance Data
//   const fetchChartData = async () => {
//     if (!selectedUser || compareInverters.length === 0) {
//       alert("Please select a user and at least one inverter!");
//       return;
//     }

//     setLoading(true);
//     try {
//       let datasets = [];
//       let labels = [];
//       // IDs of current user's inverters (for validity)
//       const validInverterIds = new Set(inverters.map(inv => inv.feeder_id));

//       for (const inv of compareInverters) {
//         // Remove the line that checks validInverterIds

//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             LOGIN_ID: selectedUser.ID,
//             LOC_CODE: selectedUser.loc_code,
//             PASS_KEY: selectedUser.password,
//             WEB_KEY: "WEBXYZ321",
//             MTR_NO: inv.feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         });

//         const apiData = res.data.data || [];
//         if (apiData.length === 0) continue; // Only skip if the inverter has no data for this user

//         const invLabels = apiData.map(d => d.DATET || d.date || "");
//         const values = apiData.map(d => parseFloat(d[metric] ?? 0));
//         if (labels.length === 0) labels = invLabels;

//         datasets.push({
//           label: `${inv.name} (${inv.user_name || selectedUser.user_name})`,
//           data: values,
//           borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
//           fill: false,
//           tension: 0.3,
//         });

//       }


//       if (datasets.length === 0) {
//         alert("No data available for selected inverters and dates!");
//         setChartData(null);
//       } else {
//         setChartData({ labels, datasets });
//       }
//     } catch (err) {
//       console.error("Chart API Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };


//   return (
//     <div style={{ padding: "10px" }}>
//       <div
//         style={{
//           borderTop: "1px solid #ccc",
//           borderRadius: "6px",
//           padding: "8px",
//           backgroundColor: "white",
//           boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
//         }}
//       >
//         <h5 style={{ margin: 0 }}>Analytics </h5>
//       </div>

//       {/* USER - INVERTER - COMPARE */}
//       <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: 10 }}>
//         {/* User List */}
//         <div style={panelStyle}>
//           <h6>User</h6>
//           <ul style={listStyle}>
//             {users.map((u) => (
//               <li key={u.ID} style={listItem}>
//                 <input
//                   type="radio"
//                   name="user"
//                   checked={selectedUser?.ID === u.ID}
//                   onChange={() => handleUserSelect(u)}
//                 />
//                 <span style={nameStyle}>{u.user_name}</span>
//                 <span style={capStyle}>[{u.capacity}]</span>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Inverters */}
//         <div style={panelStyle}>
//           <h6>Inverters</h6>
//           <ul style={listStyle}>
//             {inverters.map((inv) => (
//               <li key={inv.feeder_id} style={listItem}>
//                 <input
//                   type="checkbox"
//                   checked={compareInverters.some((c) => c.feeder_id === inv.feeder_id)}
//                   onChange={() => toggleCompareInverter(inv)}
//                 />
//                 <span style={nameStyle}>{inv.name}</span>
//                 <span style={capStyle}>[{inv.kwp}kWp]</span>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Compare Inverters */}
//         <div style={panelStyle}>
//           <h6>Compare Inverters</h6>
//           <ul style={listStyle}>
//             {compareInverters.map((c) => (
//               <li key={c.feeder_id} style={listItem}>
//                 <span style={nameStyle}>{c.name}</span>
//                 <span style={capStyle}>{c.kwp}kWp</span>
//                 <button style={removeBtn} onClick={() => toggleCompareInverter(c)}>
//                   Remove
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>

//       {/* Filters */}
//       <div style={filterStyle}>
//         <label style={labelStyle}>Select Type:</label>
//         <select value={metric} onChange={(e) => setMetric(e.target.value)} style={selectStyle}>
//           <option value="ENG">Energy Generation</option>
//           <option value="CUF">CUF</option>
//           <option value="Specific_Yield">Specific Yield</option>
//           <option value="Specific_Power">Specific Power</option>
//           <option value="KW_MAX">Peak Generation</option>
//           <option value="PR">PR</option>
//         </select>

//         <label style={labelStyle}>From:</label>
//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputStyle} />

//         <label style={labelStyle}>To:</label>
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputStyle} />

//         <TbRefresh
//           style={{ fontSize: "1.5rem", cursor: "pointer" }}
//           onClick={fetchChartData}
//           title="Refresh Chart"
//         />

// <DownloadJpegButton targetRef={chartRef} fileName={`Analytics.jpeg`} />
//       </div>

//       {/* Chart */}
//       {chartData && (
//         <div
//           style={{
//             marginTop: 12,
//             backgroundColor: "white",
//             borderRadius: 8,
//             padding: 10,
//             height: 300,
//             width: "100%",
//             boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
//           }}
//           ref={chartRef} 
//         >
//           <Line
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,
//               plugins: {
//                 legend: { position: "top", labels: { font: { size: 12 } } },
//                 // title: { display: true, text: `Inverter Performance (${metric})`, font: { size: 14 } },
//               },
//               scales: {
//                 x: { ticks: { font: { size: 11 } } },
//                 y: { ticks: { font: { size: 11 } } },
//               },
//             }}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

/* ---------- Inline Style Objects ---------- */
// const panelStyle = {
//   flex: 1,
//   minWidth: 200,
//   border: "1px solid #ccc",
//   borderRadius: 6,
//   padding: 10,
//   maxHeight: 170,
//   overflowY: "auto",
//   backgroundColor: "white",
//   boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
// };

// const listStyle = { listStyle: "none", padding: 0, margin: 0 };
// const listItem = { display: "flex", alignItems: "center", gap: 6, marginBottom: 6 };
// const nameStyle = { fontSize: 13 };
// const capStyle = { color: "#888", fontSize: 12 };
// const removeBtn = {
//   marginLeft: "auto",
//   background: "#ff5252",
//   color: "white",
//   border: "none",
//   padding: "2px 6px",
//   borderRadius: 4,
//   cursor: "pointer",
//   fontSize: 11,
// };

// const filterStyle = {
//   marginTop: 10,
//   display: "flex",
//   alignItems: "center",
//   gap: 10,
//   flexWrap: "wrap",
//   backgroundColor: "#f9f9f9",
//   padding: 10,
//   borderRadius: 6,
//   boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
// };

// const labelStyle = { fontSize: 14, fontWeight: 500 };
// const inputStyle = {
//   fontSize: 14,
//   borderRadius: 6,
//   border: "1px solid #ccc",
//   padding: "4px 10px",
//   height: 32,
// };
// const selectStyle = {
//   fontSize: 14,
//   borderRadius: 6,
//   border: "1px solid #ccc",
//   padding: "4px 10px",
//   height: 32,
//   backgroundColor: "white",
// };

// 2.

import React, { useState, useEffect, useRef } from "react";
import { TbRefresh } from "react-icons/tb";
import axios from "axios";
import { BaseUrl } from "../../../../../../api/AxiosApi";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";


ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0];
  const oneWeekAgo = new Date(date);
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];
  return {
    Today: formattedCurrentDate,
    LastWeek: formattedOneWeekAgo,
  };
}


export default function AnalyticsTab1() {
  const chartRef = useRef();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [inverters, setInverters] = useState([]);
  const [compareInverters, setCompareInverters] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
  const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
  const [metric, setMetric] = useState("ENG");
  const [loading, setLoading] = useState(false);

  const credentials = {
    USER_ID: localStorage.getItem("LOGIN_ID"),
    Password: localStorage.getItem("PASSWORD"),
    SS_KEY: localStorage.getItem("SS_KEY"),
  };

  // ✅ Fetch Users
  useEffect(() => {
    axios
      .get(`${BaseUrl}CMN_07_Super/GET_USER_LIST`, { params: credentials })
      .then((res) => setUsers(res.data.data || []))
      .catch((err) => console.error("User API Error:", err));  
  }, []);

  // ✅ Fetch Inverters
  const fetchInverters = async (user) => {
    try {
      const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
        params: {
          LOGIN_ID: user.ID,
          LOC_CODE: user.loc_code,
          PASS_KEY: user.password,
          WEB_KEY: "WEBXYZ321",
          TYP: "I",
        },
      });
      setInverters(res.data.FEED || []);
    } catch (err) {
      console.error("Inverter API Error:", err);
    }
  };

  // ✅ Handle user select
  const handleUserSelect = (user) => {
    setSelectedUser(user);
    fetchInverters(user);
  };

  // ✅ Add/remove inverter for comparison
  const toggleCompareInverter = (inv) => {
    setCompareInverters((prev) => {
      const exists = prev.some((c) => c.feeder_id === inv.feeder_id);
      if (exists) {
        return prev.filter((c) => c.feeder_id !== inv.feeder_id);
      }
      return [
        ...prev,
        {
          ...inv,
          user_name: selectedUser.user_name,
          ID: selectedUser.ID,
          loc_code: selectedUser.loc_code,
          password: selectedUser.password,
        },
      ];
    });
  };

  // ✅ Fetch chart data
  const fetchChartData = async () => {
    if (compareInverters.length === 0) {
      alert("Please select at least one inverter!");
      return;
    }

    setLoading(true);
    try {
      let datasets = [];
      let labels = [];
      let noDataInverters = [];

      for (const inv of compareInverters) {
        try {
          const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
            params: {
              LOGIN_ID: inv.ID,
              LOC_CODE: inv.loc_code,
              PASS_KEY: inv.password,
              WEB_KEY: "WEBXYZ321",
              MTR_NO: inv.feeder_id,
              DT1: fromDate,
              DT2: toDate,
            },
          });

          const apiData = res.data.data || [];
          if (!apiData.length) {
            noDataInverters.push(inv.name);
            continue;
          }

          const invLabels = apiData.map((d) => d.DATET || d.date || "");
          const values = apiData.map((d) => parseFloat(d[metric] ?? 0));
          if (labels.length === 0) labels = invLabels;

          datasets.push({
            label: `${inv.name} (${inv.user_name})`,
            data: values,
            borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
            borderWidth: 2,
            fill: false,
            tension: 0.3,
          });
        } catch (err) {
          console.error(`Data fetch failed for inverter ${inv.name}:`, err);
        }
      }

      if (datasets.length === 0) {
        alert("No data found for the selected inverters!");
        setChartData(null);
      } else {
        setChartData({ labels, datasets });
        if (noDataInverters.length > 0)
          alert(`No data available for: ${noDataInverters.join(", ")}`);
      }
    } catch (err) {
      console.error("Chart API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "10px" }}>
      <div
        style={{
          borderTop: "1px solid #ccc",
          borderRadius: "6px",
          padding: "8px",
          backgroundColor: "white",
          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        <h5 style={{ margin: 0 }}>Analytics </h5>
      </div>

      {/* USER - INVERTER - COMPARE */}
      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: 10 }}>
        {/* User List */}
        <div style={panelStyle}>
          <h6>User</h6>
          <ul style={listStyle}>
            {users.map((u) => (
              <li key={u.ID} style={listItem}>
                <input
                  type="radio"
                  name="user"
                  checked={selectedUser?.ID === u.ID}
                  onChange={() => handleUserSelect(u)}
                />
                <span style={nameStyle}>{u.user_name}</span>
                <span style={capStyle}>[{u.capacity}]</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Inverters */}
        <div style={panelStyle}>
          <h6>Inverters</h6>
          <ul style={listStyle}>
            {inverters.map((inv) => (
              <li key={inv.feeder_id} style={listItem}>
                <input
                  type="checkbox"
                  checked={compareInverters.some((c) => c.feeder_id === inv.feeder_id)}
                  onChange={() => toggleCompareInverter(inv)}
                />
                <span style={nameStyle}>{inv.name}</span>
                <span style={capStyle}>[{inv.kwp}kWp]</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Compare Inverters */}
        <div style={panelStyle}>
          <h6>Compare Inverters</h6>
          <ul style={listStyle}>
            {compareInverters.map((c) => (
              <li key={c.feeder_id} style={listItem}>
                <span style={nameStyle}>{c.name}</span>
                <span style={capStyle}>{c.kwp}kWp</span>
                <button style={removeBtn} onClick={() => toggleCompareInverter(c)}>
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Filters */}
      <div style={filterStyle}>
        <label style={labelStyle}>Select Type:</label>
        <select value={metric} onChange={(e) => setMetric(e.target.value)} style={selectStyle}>
          <option value="ENG">Energy Generation</option>
          <option value="CUF">CUF</option>
          <option value="Specific_Yield">Specific Yield</option>
          <option value="Specific_Power">Specific Power</option>
          <option value="KW_MAX">Peak Generation</option>
          <option value="PR">PR</option>
        </select>

        <label style={labelStyle}>From:</label>
        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputStyle} />

        <label style={labelStyle}>To:</label>
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputStyle} />

        <TbRefresh
          style={{ fontSize: "1.5rem", cursor: "pointer" }}
          onClick={fetchChartData}
          title="Refresh Chart"
        />

        <DownloadJpegButton targetRef={chartRef} fileName={`Analytics.jpeg`} />
      </div>

      {/* Chart */}
      {chartData && (
        <div
          style={{
            marginTop: 12,
            backgroundColor: "white",
            borderRadius: 8,
            padding: 10,
            height: 300,
            width: "100%",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          }}
          ref={chartRef}
        >
          <Line
            data={chartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { position: "top", labels: { font: { size: 12 } } },
                // title: { display: true, text: `Inverter Performance (${metric})`, font: { size: 14 } },
              },
              scales: {
                x: { ticks: { font: { size: 11 } } },
                y: { ticks: { font: { size: 11 } } },
              },
            }}
          />
        </div>
      )}
    </div>
  );
}




const panelStyle = {
  flex: 1,
  minWidth: 200,
  border: "1px solid #ccc",
  borderRadius: 6,
  padding: 10,
  maxHeight: 170,
  overflowY: "auto",
  backgroundColor: "white",
  boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
};

const listStyle = { listStyle: "none", padding: 0, margin: 0 };
const listItem = { display: "flex", alignItems: "center", gap: 6, marginBottom: 6 };
const nameStyle = { fontSize: 13 };
const capStyle = { color: "#888", fontSize: 12 };
const removeBtn = {
  marginLeft: "auto",
  background: "#ff5252",
  color: "white",
  border: "none",
  padding: "2px 6px",
  borderRadius: 4,
  cursor: "pointer",
  fontSize: 11,
};

const filterStyle = {
  marginTop: 10,
  display: "flex",
  alignItems: "center",
  gap: 10,
  flexWrap: "wrap",
  backgroundColor: "#f9f9f9",
  padding: 10,
  borderRadius: 6,
  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
};

const labelStyle = { fontSize: 14, fontWeight: 500 };
const inputStyle = {
  fontSize: 14,
  borderRadius: 6,
  border: "1px solid #ccc",
  padding: "4px 10px",
  height: 32,
};
const selectStyle = {
  fontSize: 14,
  borderRadius: 6,
  border: "1px solid #ccc",
  padding: "4px 10px",
  height: 32,
  backgroundColor: "white",
};


